import { useFormik } from 'formik';
import { useStores } from 'Hooks/useStore';
import { getAppRoutes } from 'Pages/App/App.constants';
import { useHistory } from 'react-router-dom';

interface UseLoginOptions {
	redirectTo?: string;
}

const useLogin = (options?: UseLoginOptions) => {
	const { authStore } = useStores();
	const history = useHistory();

	const redirectPath = options?.redirectTo ?? getAppRoutes().HOME;

	const formik = useFormik({
		initialValues: {
			username: '',
			password: ''
		},

		validate: (values) => {
			const errors: {
				username?: string;
				password?: string;
			} = {};

			if (!values.username.trim()) {
				errors.username = 'Username is required';
			}

			if (!values.password.trim()) {
				errors.password = 'Password is required';
			}

			return errors;
		},

		onSubmit: async (values, { setSubmitting, setStatus }) => {
			try {
				localStorage.clear();

				await authStore.signIn({
					login: values.username,
					password: values.password
				});

				history.push(redirectPath, {
					userLoggedIn: true
				});
			} catch (error: any) {
				setStatus(error?.message || 'Something went wrong!');
			} finally {
				setSubmitting(false);
			}
		}
	});

	return formik;
};

export default useLogin;
